import { useIntl } from "react-intl";
import { type BasicUsageCardLoaderProps, UsageCard } from "./UsageCard.js";
import { calculateUsageCost, TieredPriceProductId } from "@project/common";
import { IconUsersGroup } from "@tabler/icons-react";
import { INTERNATIONALIZED_UNIT_LABELS } from "../../../constants/productLabels.js";
import { useTeamSeatsUsageSum } from "./hooks/fetchSums.js";
import { useProductDescriptions, useProductNames } from "./hooks/productLabels.js";
import type { To } from "./UsageChartWrapper.js";

export function TeamSeatsUsageCard({
  to,
  productId,
  isLoadingSubscriptions,
}: BasicUsageCardLoaderProps & To) {
  const intl = useIntl();
  const getName = useProductNames();
  const getDescription = useProductDescriptions();
  const { usageSum, isLoadingTeamSeats, isErrorTeamSeats } = useTeamSeatsUsageSum({ to });
  const unitLabel = intl.formatMessage(INTERNATIONALIZED_UNIT_LABELS.team_member);

  return (
    <UsageCard
      productId={productId}
      usageSum={usageSum}
      unitLabel={unitLabel}
      icon={<IconUsersGroup />}
      iconColor="teal.5"
      isError={isErrorTeamSeats}
      isLoading={isLoadingSubscriptions || isLoadingTeamSeats}
      usageCost={calculateUsageCost(usageSum, productId)}
      name={getName(TieredPriceProductId.TieredAccountUser)}
      description={getDescription(TieredPriceProductId.TieredAccountUser)}
      defaultProductId={TieredPriceProductId.TieredAccountUser}
    />
  );
};
